export default __webpack_public_path__ + "static/media/fridge2-afterA-480w.47a8f9fb.avif";